module.exports = __webpack_public_path__ + "media/images/cows/Pregnant cow in second trimester.jpg";